import { render } from "./UsoUsuarios.vue?vue&type=template&id=d8cffc1a&scoped=true"
import script from "./UsoUsuarios.vue?vue&type=script&lang=js"
export * from "./UsoUsuarios.vue?vue&type=script&lang=js"

import "./UsoUsuarios.vue?vue&type=style&index=0&id=d8cffc1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8cffc1a"]])

export default __exports__